import React from 'react';
import { AuthenticationConsumer } from './Contexts/AuthenticationContext';

export default function withAuthentication(Component) {
  return function AuthAwareComponent(props) {
    return (
      <AuthenticationConsumer>
        {authentication => (
          <Component {...props} authentication={authentication} />
        )}
      </AuthenticationConsumer>
    );
  };
}
